import React from 'react';

const Android = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Native Android Development</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">Android</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Enterprise Native Android Development</h1>
                                    
                                    <p className="lead">We develop native Android applications using Kotlin and Java. Our applications deliver exceptional performance, security, and user experience across Android devices, from smartphones to tablets and wearables.</p>

                                    <h3 className="mt-50">Kotlin: The Modern Android Standard</h3>
                                    <p>Kotlin has become the official language for Android app development. Its concise syntax, null safety, and excellent tooling make it the ideal choice for building robust Android applications.</p>

                                    <h3 className="mt-40">Complete Android Capabilities</h3>
                                    <ul>
                                        <li><strong>Native Performance:</strong> Direct access to Android framework for optimal speed</li>
                                        <li><strong>Kotlin & Java Support:</strong> Modern Kotlin with Java interoperability</li>
                                        <li><strong>Google Play Integration:</strong> Full support for Play Store features</li>
                                        <li><strong>Material Design:</strong> Beautiful Material Design 3 interfaces</li>
                                        <li><strong>Access to Device Features:</strong> Camera, sensors, location, contacts</li>
                                        <li><strong>Advanced Security:</strong> Biometric auth, encryption, secure storage</li>
                                        <li><strong>Wearable & IoT Support:</strong> Android Wear, Android Things</li>
                                        <li><strong>Architecture Components:</strong> Room, LiveData, ViewModel</li>
                                    </ul>

                                    <h3 className="mt-40">Diverse Android Solutions</h3>
                                    <p><strong>Consumer Apps:</strong> High-quality consumer applications with millions of users.</p>
                                    <p><strong>Enterprise Solutions:</strong> Complex business apps for large organizations.</p>
                                    <p><strong>IoT Applications:</strong> Connected devices and sensors management.</p>

                                    <h3 className="mt-40">AppCore's Android Excellence</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Enterprise Android Platform</h5>
                                        <p>We built a comprehensive Android platform:</p>
                                        <ul>
                                            <li>🏢 Enterprise security & compliance</li>
                                            <li>📱 Supporting 100+ device types</li>
                                            <li>⚡ Optimized for Android 13+</li>
                                            <li>🎯 Google Play rating: 4.7/5 stars</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Advanced Kotlin Development</h3>
                                    <ul>
                                        <li>Jetpack Compose for modern UI development</li>
                                        <li>LiveData & ViewModel for state management</li>
                                        <li>Coroutines for asynchronous operations</li>
                                        <li>Room database for local persistence</li>
                                        <li>Firebase integration for backend services</li>
                                        <li>Unit & UI testing with Espresso & JUnit</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">Android Capabilities</h5>
                                    <ul className="sidebar-list">
                                        <li>⚡ Native Performance</li>
                                        <li>🔒 Advanced Security</li>
                                        <li>🎨 Material Design 3</li>
                                        <li>📱 Phone & Tablet</li>
                                        <li>⌚ Wearable Support</li>
                                        <li>🌐 IoT Integration</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Delivery Excellence</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Android Apps</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>55+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Play Store Rating</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>4.7/5</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">ANR-Free Rate</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.8%</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Android Market Leaders</h5>
                                    <p className="small">Our Android expertise spans consumer, enterprise, financial, healthcare, and IoT sectors meeting Google Play's highest standards.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Android;
